const stats = [
  { value: "+15", label: "Años de experiencia", icon: "ri-calendar-check-line" },
  { value: "+500", label: "Clientes atendidos", icon: "ri-time-line" },
  { value: "+2.000", label: "Servicios realizados", icon: "ri-truck-line" },
  { value: "100%", label: "Clientes satisfechos", icon: "ri-star-line" },
];

export default function StatsSection() {
  return (
    <section className="bg-[#1a1a1a] py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/20 rounded-full mx-auto mb-4">
                <i className={`${s.icon} text-[#FF6B35] text-2xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-white mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                {s.value}
              </div>
              <div className="text-gray-400 text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
